import React from 'react';
import { connect } from 'react-redux';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import { ErrorComponent } from '@trp-rps-rps-shared-web/rps-shared-web-components';
import { modalActions } from '../../redux/root-action';
import styled from 'styled-components';

const StyledHeader = styled.div`
  border-radius: 4px;
  font-family: Nimbus Sans Bold;
  font-size: 24px;
  line-height: 1.33;
  letter-spacing: -0.5px;
  color: ${tokens.ColorGrey900};
  display: flex;
  justify-content: space-between;
  @media only screen and (max-width: 767px) {
    font-size: 20px;
  }
`;

const StyledDivider = styled.div`
  border-bottom: 1px solid ${tokens.ColorWhite100};
  margin: 0px 48px 0px 48px;
  @media only screen and (max-width: 767px) {
    margin: 0px;
  }
`;

const StyledErrorContainer = styled.div`
  margin: 32px 48px 0px 48px;
  @media only screen and (max-width: 767px) {
    margin: 16px 16px 0px 16px;
  }
`;

const StyledModalTitle = styled.div`
  padding: 48px 24px 24px 48px;
  @media only screen and (max-width: 767px) {
    padding: 24px 16px 24px 16px;
  }
`;

const CloseIconButton = styled.a`
  outline: none;
  border: none;
  background-color: transparent;
`;

const CloseIcon = styled.img`
  margin: 24px;
  height: 24px;
  width: 24px;
  cursor: pointer;
`;

interface Props {
  modalTitle?: string;
  showClose?: boolean;
  showCloseInMobile?: boolean;
  errorMessage?: string;
  handleCloseIconClick?: () => void;
}

class ReactModalHeader extends React.Component<Props> {
  props: any;
  divElement: HTMLDivElement | null = null;
  componentDidMount() {
    const { setModalHeaderHeight } = this.props;
    const headerHeight = this.divElement ? this.divElement.clientHeight : 0;
    setModalHeaderHeight(headerHeight);
  }
  componentDidUpdate() {
    const { setModalHeaderHeight } = this.props;
    const headerHeight = this.divElement ? this.divElement.clientHeight : 0;
    setModalHeaderHeight(headerHeight);
  }

  handleKeyPress = (e: any) => {
    const btn = document.querySelector('#modal-header-close-icon') as HTMLElement | null;
    if (e.nativeEvent.code === 'Enter') {
      btn && btn.click();
    }
  };

  render(): any {
    const {
      hideModal,
      handleCloseIconClick,
      showClose,
      modalTitle,
      errorMessage,
      showCloseInMobile = false,
    } = this.props;
    const mq = window.matchMedia('(max-width: 767px)');
    return (
      <div
        ref={(element: HTMLDivElement) => {
          this.divElement = element;
        }}
      >
        <StyledHeader>
          <StyledModalTitle tabIndex={0}>{modalTitle}</StyledModalTitle>
          {(showClose || (mq.matches && showCloseInMobile)) && (
            <CloseIconButton
              id={`modal-header-close-icon`}
              onClick={handleCloseIconClick ? handleCloseIconClick : hideModal}
              tabIndex={0}
              onKeyPress={this.handleKeyPress}
            >
              <CloseIcon src={`data:image/svg+xml;base64,${tokens.AssetIconClose}`} alt="Close icon" />
            </CloseIconButton>
          )}
        </StyledHeader>
        <StyledDivider />
        {errorMessage && (
          <StyledErrorContainer id={`modal-header-error`}>
            <ErrorComponent id={`modal-header-error-comp`} message={errorMessage} />
          </StyledErrorContainer>
        )}
      </div>
    );
  }
}

export default connect(null, {
  hideModal: modalActions.hideModal,
  setModalHeaderHeight: modalActions.setModalHeaderHeight,
})(ReactModalHeader);
